import actionTypes from './action-types';
import socketService from '../services/socket.service';
import cryptoService from '../services/crypto.service';

export function receiveAccounts(accounts, error?) {
  return {
    type: actionTypes.RECEIVE_ACCOUNTS,
    accounts:
      accounts &&
      accounts.reduce((acc, value) => {
        value.balance = Number(cryptoService.decrypt(value.balance));
        acc[value._id] = value;
        return acc;
      }, {}),
    error
  };
}

export function fetchAccounts() {
  return async dispatch => {
    try {
      const accounts = await socketService.emit('accountsList');
      dispatch(receiveAccounts(accounts));
    } catch (e) {
      receiveAccounts(null, e);
    }
  };
}

export function fetchAccount(_id) {
  return async dispatch => {
    const account = await socketService.emit('accounts', { _id });
    dispatch(receiveAccounts([account]));
  };
}

export function updateAccount(account) {
  return async dispatch => {
    try {
      account.balance = cryptoService.encrypt(account.balance);
      const saved = await socketService.emit(account._id ? 'accountsUpdate' : 'accountsAdd', account);
      dispatch(receiveAccounts([saved]));
    } catch (e) {
      dispatch(receiveAccounts(null, e));
    }
  };
}

export function deletedAccount({ _id }) {
  return {
    type: actionTypes.DELETED_ACCOUNT,
    _id
  };
}

export function deleteAccount(_id) {
  return async dispatch => {
    const expense = await socketService.emit('accountsDelete', { _id });
    expense && dispatch(deletedAccount(expense));
  };
}



// WEBPACK FOOTER //
// ./src/actions/accounts.ts